import { createAsyncAction } from 'typesafe-actions'
import { INonDeliveryDay } from '../../../api'

export const FETCH_NON_DELIVERY_DAYS = createAsyncAction(
  'order/FETCH_NON_DELIVERY_DAYS',
  'order/FETCH_NON_DELIVERY_DAYS_SUCCESS',
  'order/FETCH_NON_DELIVERY_DAYS_FAILURE',
  'order/FETCH_NON_DELIVERY_DAYS_CANCEL',
)<undefined, INonDeliveryDay[], Error, undefined>()
